<p-floatLabel class="m-5">
  <input
    id="name"
    pInputText
    [(ngModel)]="documentsSpaceName"
    styleClass="w-full"
    style="width: 100%"
  />
  <label for="name">
    <ng-container i18n="@@documents_space_list_name_column">Nom de l'espace partagé</ng-container>
  </label>
</p-floatLabel>
@if (documentsSpaceOwnerName === "" || accountService.getAccountName() === documentsSpaceOwnerName) {
  <br />
  <p-floatLabel class="m-5">
    <p-multiSelect
      [options]="usersOptions"
      [(ngModel)]="selectedAdmins"
      optionLabel="name"
      optionValue="name"
      [style]="{ width: '100%' }"
      appendTo="body"
      [virtualScroll]="true"
      [virtualScrollItemSize]="30"
      [showToggleAll]="false"
      [maxSelectedLabels]="5"
    />
    <label for="name">
      <ng-container i18n="@@documents_space_settings_admins">Administré par</ng-container>
    </label>
  </p-floatLabel>
}
<br />
<p-floatLabel class="m-5">
  <p-multiSelect
    [options]="usersOptions"
    [(ngModel)]="selectedUsers"
    optionLabel="name"
    optionValue="name"
    [style]="{ width: '100%' }"
    appendTo="body"
    [virtualScroll]="true"
    [virtualScrollItemSize]="30"
    [showToggleAll]="false"
    [maxSelectedLabels]="5"
  />
  <label for="name">
    <ng-container i18n="@@documents_space_settings_shared_with">Partagé avec</ng-container>
  </label>
</p-floatLabel>
<br />
<p-floatLabel class="m-5">
  <p-dropdown
    [options]="modelOptions"
    [(ngModel)]="selectedModel"
    optionLabel="displayedName"
    optionValue="technicalName"
    [style]="{ width: '100%' }"
    appendTo="body"
  />
  <label for="name">
    <ng-container i18n="@@documents_space_settings_model_dropdown">Modèle de langage (LLM)</ng-container>
  </label>
</p-floatLabel>
<div class="mb-2">
  @if (files.length > 0) {
    <span class="text-sm font-italic">
      <ng-container i18n="@@chat_line_files_text">Fichiers:</ng-container>
    </span>
    @for (file of files; track file) {
      <p-chip
        class="m-2"
        [label]="file.filename"
        [removable]="true"
        (onRemove)="removeSelectedFile(file.id)"
      />
    }
  }
</div>

<button
  class="p-button-primary my-2"
  type="button"
  pButton
  label="Ajouter des fichiers à l'espace"
  i18n-label="@@documents_space_settings_add_files"
  icon="pi pi-paperclip"
  tooltipPosition="top"
  (click)="openDialogToAddFiles()"
></button>

<div>
  <button
    class="p-button-success"
    pButton
    (click)="createOrEdit()"
    type="button"
    [label]="settingsMode === 'CREATE' ? 'Créer' : 'Modifier'"
    i18n-label="
      settingsMode === 'CREATE' ? '@@documents_space_list_create_button' : '@@documents_space_details_edit_button'"
    [disabled]="!documentsSpaceName || files.length === 0"
  ></button>
</div>
